// src/pages/GroupedApplicationsDeputy2.jsx
// Объединённый компонент: GroupedApplicationsDeputy2 + InExpertiseApplicationsZam2
import React, { useEffect, useMemo, useState, useCallback } from 'react';
import axios from '../api/axios';
import './GroupedApplicationsDeputy2.css';
import ApplicationViewDeputy2 from './ApplicationViewDeputy2';
import AssignStaffPopover from '../components/assign/AssignStaffPopover';
import ResponsibleAvatars from '../components/responsibles/ResponsibleAvatars';
import SignatureApplicationModal from '../pages/modals/SignatureApplicationModal';
import ApplicationReviewModal from './modals/ApplicationReviewModal';
import ChatBox from './modals/ChatBox';
import UserProfileModal from '../components/users/UserProfileModal';

/* ─── helpers (как в DirectorInboxTab) ─────────────────────── */
const localizedName = (v, locale = 'kz', fallback = '—') => {
  if (v == null || v === '') return fallback;
  if (typeof v === 'string' || typeof v === 'number') return String(v);
  const lang = locale === 'ru' ? 'ru' : 'kz';
  return v[`name_${lang}`] || v.name || v.title || v.label || fallback;
};

export default function GroupedApplicationsDeputy2({ locale = 'kz' }) {
  const token = localStorage.getItem('token');

  /* ===================== i18n ===================== */
  const t = {
    kz: {
      group: 'Топ атауы',
      view: 'Толық көру',
      viewExperts: 'Сарапшылар',
      sign: 'Қол қою',
      empty: 'Топтар табылмады',
      accept: 'Қол қою',
      assign: 'Бөлім басшысына жіберу',
      selectHead: 'Бөлім басшысын таңдаңыз',
      successAssign: 'Бөлім басшысына сәтті жіберілді!',
      successApprove: 'Барлық өтінімдер сәтті қабылданды!',
      loading: 'Жүктелуде...',
      confirmApprove: 'Сіз барлық өтінімдерге қол қоюды растайсыз ба?',
      confirmAssign: 'Сіз осы басшыға жібретініңізге сенімдісіз бе?',
      error: 'Қате орын алды',
      expandAll: 'Барлығын ашу',
      collapseAll: 'Барлығын жабу',
      apps: 'Өтінімдер',
      overdue: 'Мерзімі өтті',
      start: 'Басталуы',
      deadline: 'Дедлайн',
      assignees: 'Тағайындалғандар',
      assignBtn: 'Тағайындау',
      modalTitle: 'Қызметкерлерді тағайындау',
      cancel: 'Болдырмау',
      save: 'Сақтау',
      staffEmpty: 'Қызметкерлер табылмады',
      pagination: { prev: 'Алдыңғы', next: 'Келесі' },
      filterUnassigned: 'Тек тағайындалмағандар',
      filterAll: 'Барлығы',
      tableHeaders: {
        title: 'Оқу басылымы',
        grade: 'Сынып',
        language: 'Әзірлеу тілі',
        category: 'Санат',
        publisher: 'Баспа (шифр)',
        status: 'Күйі',
        date: 'Күні',
        action: '',
      },
      alerts: {
        errorOccurred: 'Қате орын алды',
        fileNotLoaded: '❗ Құжат жүктелмеді',
        signError: '❌ Қате: ',
        signSuccess: '✅ Қол қойылды!',
        rejectQueueError: 'Қате: қол қою кезегінде жоқсыз',
        rejectSuccess: '❌ Қабылдамадыңыз',
        generalRejectError: 'Қате',
        fileDownloadError: 'Файлды жүктеу қатесі',
      },
      // Общая информация группы
      groupInfoTitle: 'Топ туралы жалпы ақпарат',
      registration_number: 'Тіркеу нөмірі',
      noRegistrationNumber: 'Тіркеу нөмірі жоқ',
      subject: 'Пән',
      grade: 'Сынып',
      education_level: 'Білім деңгейі',
      direction: 'Бағыт',
      development_language: 'Әзірлеу тілі',
      teaching_language: 'Оқыту тілі',
      publication_type: 'Басылым түрі',
      service_type: 'Қызмет түрі',
      submission_year: 'Өткізу жылы',
      sent_at: 'Жіберілген күні',
      head: 'Бөлім басшысы',
      responsibles: 'Жауапты қызметкерлер',
    },
    ru: {
      group: 'Название группы',
      view: 'Просмотр',
      viewExperts: 'Эксперты',
      sign: 'Подписать',
      empty: 'Группы не найдены',
      accept: 'Подписать',
      assign: 'Направить руководителю',
      selectHead: 'Выберите руководителя',
      successAssign: 'Успешно направлен Руководителю!',
      successApprove: 'Все заявки успешно подписаны!',
      loading: 'Загрузка...',
      confirmApprove: 'Вы подтверждаете подписание всех заявок?',
      confirmAssign: 'Вы уверены, что хотите направить этому руководителю?',
      error: 'Произошла ошибка',
      expandAll: 'Развернуть все',
      collapseAll: 'Свернуть все',
      apps: 'Заявок',
      overdue: 'Просрочено',
      start: 'Начало',
      deadline: 'Дедлайн',
      assignees: 'Назначено',
      assignBtn: 'Назначить',
      modalTitle: 'Назначить сотрудников',
      cancel: 'Отмена',
      save: 'Сохранить',
      staffEmpty: 'Сотрудники не найдены',
      pagination: { prev: 'Назад', next: 'Вперёд' },
      filterUnassigned: 'Только без назначенных',
      filterAll: 'Все',
      tableHeaders: {
        title: 'Учебное издание',
        grade: 'Класс',
        language: 'Язык разработки',
        category: 'Категория',
        publisher: 'Издательство (шифр)',
        status: 'Статус',
        date: 'Дата',
        action: '',
      },
      alerts: {
        errorOccurred: 'Произошла ошибка',
        fileNotLoaded: '❗ Файл не загружен',
        signError: '❌ Ошибка: ',
        signSuccess: '✅ Подпись успешна!',
        rejectQueueError: 'Ошибка: вы не в очереди на подпись',
        rejectSuccess: '❌ Вы отклонили',
        generalRejectError: 'Ошибка',
        fileDownloadError: 'Ошибка при загрузке файла',
      },
      // Общая информация группы
      groupInfoTitle: 'Общая информация группы',
      registration_number: 'Регистрационный номер',
      noRegistrationNumber: 'Регистрационный номер отсутствует',
      subject: 'Предмет',
      grade: 'Класс',
      education_level: 'Уровень образования',
      direction: 'Направление',
      development_language: 'Язык разработки',
      teaching_language: 'Язык обучения',
      publication_type: 'Тип издания',
      service_type: 'Тип услуги',
      submission_year: 'Год подачи',
      sent_at: 'Дата отправки',
      head: 'Руководитель отдела',
      responsibles: 'Ответственные сотрудники',
    },
  }[locale];

  /* ===================== state ===================== */
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [userId, setUserId] = useState(null);

  const [onlyUnassigned, setOnlyUnassigned] = useState(false);

  const [expanded, setExpanded] = useState(() => {
    try { return JSON.parse(localStorage.getItem('gad2_expanded_groups') || '{}'); } catch { return {}; }
  });
  const anyOpen = useMemo(() => groups.some((g) => expanded[g.id]), [groups, expanded]);

  const [selectedApplicationId, setSelectedApplicationId] = useState(null);
  const [heads, setHeads] = useState([]);
  const [assigningGroupId, setAssigningGroupId] = useState(null);
  const [approvingGroupId, setApprovingGroupId] = useState(null);
  const [selectingGroupId, setSelectingGroupId] = useState(null);

  const [sortBy, setSortBy] = useState('created_at');
  const [sortDir, setSortDir] = useState('desc');

  const [meta, setMeta] = useState({ total: 0, per_page: 10, current_page: 1, last_page: 1, from: 0, to: 0 });
  const [page, setPage] = useState(1);
  const [statusFilter, setStatusFilter] = useState('all');

  const [assignOpen, setAssignOpen] = useState(false);
  const [assignGroup, setAssignGroup] = useState(null);
  const [assignAnchorEl, setAssignAnchorEl] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const [saving, setSaving] = useState(false);

  const [, forceMinuteTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => forceMinuteTick((x) => x + 1), 60 * 1000);
    return () => clearInterval(id);
  }, []);

  const [selectedApplication, setSelectedApplication] = useState(null);
  const [finalAverage, setFinalAverage] = useState(null);
  const [summaryDecision, setSummaryDecision] = useState('');
  const [signatures, setSignatures] = useState([]);
  const [pendingSignatures, setPendingSignatures] = useState([]);
  const [showSignatures, setShowSignatures] = useState(false);
  const [base64File, setBase64File] = useState('');
  const [openingSign, setOpeningSign] = useState(false);

  const [reviewApp, setReviewApp] = useState(null);
  const [reviewFinalAverage, setReviewFinalAverage] = useState(null);
  const [reviewSummaryDecision, setReviewSummaryDecision] = useState('');
  const [reviewExperts, setReviewExperts] = useState([]);
  const [reviewFinalDocuments, setReviewFinalDocuments] = useState([]);
  const [openingReview, setOpeningReview] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);

  const [profileOpen, setProfileOpen] = useState(false);
const [profileUser, setProfileUser] = useState(null);
const [profileDetails, setProfileDetails] = useState(null);
const [profileLoading, setProfileLoading] = useState(false);

  const langHeader = locale === 'ru' ? 'ru' : 'kz';
  const authHeaders = useMemo(
    () => ({ Authorization: `Bearer ${token}`, 'Accept-Language': langHeader }),
    [token, langHeader]
  );
  const staffParams = useMemo(() => ({ per_page: 200, status: 'белсенді', roles: 'department_supervisor' }), []);

  /* ===================== responsible helpers ===================== */
  const getResponsibles = (g) =>
    (Array.isArray(g?.responsibles) && g.responsibles) ||
    (Array.isArray(g?.assignees) && g.assignees) || [];

  const respId = (u) => u?.user_id ?? u?.id ?? null;

  const openAssign = useCallback((g, anchorEl) => {
    setAssignGroup(g);
    setSelectedIds(getResponsibles(g).map((u) => respId(u)).filter(Boolean));
    setAssignAnchorEl(anchorEl || null);
    setAssignOpen(true);
  }, []);

  const closeAssign = useCallback(() => {
    setAssignOpen(false);
    setAssignGroup(null);
    setAssignAnchorEl(null);
    setSelectedIds([]);
    setSaving(false);
  }, []);

  /* ===================== helpers ===================== */
  const getStatusName = useCallback(
    (st) => (typeof st === 'object' ? (locale === 'kz' ? st.name_kz : st.name_ru) : (st || '')),
    [locale]
  );

  const safeDate = (s) => (s ? new Date(String(s).replace(' ', 'T')) : null);

  const timeUnits = useMemo(() => (
    locale === 'ru' ? { d: 'д', h: 'ч', m: 'м' } : { d: 'күн', h: 'сағ', m: 'мин' }
  ), [locale]);

  const formatTimeLeft = useCallback((deadlineAt) => {
    if (!deadlineAt) return '—';
    const deadline = safeDate(deadlineAt);
    if (!deadline) return '—';
    const diffMs = deadline - new Date();
    if (diffMs <= 0) return t.overdue;
    const totalMin = Math.floor(diffMs / 60000);
    const d = Math.floor(totalMin / (60 * 24));
    const h = Math.floor((totalMin % (60 * 24)) / 60);
    const m = totalMin % 60;
    if (d > 0) return `${d}${timeUnits.d} ${h}${timeUnits.h} ${m}${timeUnits.m}`;
    if (h > 0) return `${h}${timeUnits.h} ${m}${timeUnits.m}`;
    return `${m}${timeUnits.m}`;
  }, [t.overdue, timeUnits]);

  const minutesUntil = useCallback((deadlineAt) => {
    if (!deadlineAt) return null;
    const d = safeDate(deadlineAt);
    if (!d) return null;
    return Math.floor((d - new Date()) / 60000);
  }, []);

  const getTimeSeverity = useCallback((deadlineAt) => {
    const mins = minutesUntil(deadlineAt);
    if (mins === null) return 'none';
    if (mins <= 0) return 'danger';
    if (mins <= 60) return 'danger';
    if (mins <= 24 * 60) return 'warn';
    return 'ok';
  }, [minutesUntil]);

  const summarizeGroup = useCallback((group) => {
    const apps = Array.isArray(group.applications) ? group.applications : [];
    let nearest = null;
    let anyOverdue = false;
    apps.forEach((a) => {
      const dl = a?.deadline;
      if (!dl || !dl.deadline_at) return;
      const ts = safeDate(dl.deadline_at)?.getTime() ?? Infinity;
      const nts = safeDate(nearest?.deadline_at)?.getTime() ?? Infinity;
      if (!nearest || ts < nts) nearest = dl;
      if (dl.is_overdue === true) anyOverdue = true;
    });
    if (!nearest) return null;
    const nowOverdue = (safeDate(nearest.deadline_at) ?? new Date(0)) < new Date();
    return {
      start_at: nearest.start_at ?? null,
      deadline_at: nearest.deadline_at ?? null,
      is_overdue: anyOverdue || nowOverdue,
      minutes_left: nearest.minutes_left ?? null,
      progress_percent: typeof nearest.progress_percent === 'number' ? nearest.progress_percent : null,
    };
  }, []);

  const groupSummaries = useMemo(() => {
    const map = {};
    groups.forEach((g) => { map[g.id] = summarizeGroup(g); });
    return map;
  }, [groups, summarizeGroup]);

  /* ===================== fetch ===================== */
  const fetchUserProfile = useCallback(async () => {
    try {
      const res = await axios.get('/internal/profile', { headers: authHeaders });
      setUserId(res.data?.id ?? null);
    } catch (err) {

    }
  }, [authHeaders]);

  const openProfile = useCallback(async (user) => {
  if (!user) return;
  setProfileUser(user);
  setProfileOpen(true);
  setProfileDetails(null);
  setProfileLoading(true);

  const uId = user?.user_id ?? user?.id;
  if (!uId) { setProfileLoading(false); return; }

  try {
    const res = await axios.get(`/backoffice/users/${uId}`, { headers: authHeaders });
    setProfileDetails(res.data?.data || res.data || null);
  } catch {
    setProfileDetails(null);
  } finally {
    setProfileLoading(false);
  }
}, [authHeaders]);

const closeProfile = useCallback(() => {
  setProfileOpen(false);
  setProfileUser(null);
  setProfileDetails(null);
  setProfileLoading(false);
}, []);

const fetchGroups = useCallback(async (p = page) => {
  setLoading(true);
  setError('');
  try {
const params = { page: p, per_page: 10 };
if (statusFilter && statusFilter !== 'all') params.status = statusFilter;
const res = await axios.get('/expertise/grouped', { headers: authHeaders, params });
    const payload = res.data;
    const items = Array.isArray(payload?.data) ? payload.data : Array.isArray(payload) ? payload : [];
    setGroups(items);
    if (payload?.meta) {
      setMeta(payload.meta);
    } else {
      const n = items.length;
      setMeta({ total: n, per_page: n, current_page: 1, last_page: 1, from: n ? 1 : 0, to: n });
    }
  } catch (err) {
    setError(err?.response?.data?.message || t.error);
    setGroups([]);
    setMeta({ total: 0, per_page: 10, current_page: 1, last_page: 1, from: 0, to: 0 });
  } finally {
    setLoading(false);
  }
}, [authHeaders, t.error, page, statusFilter]);

  const fetchAvailableHeads = useCallback(async () => {
    try {
      const res = await axios.get('/expertise/available-heads', { headers: authHeaders });
      setHeads(res.data?.heads || []);
    } catch (err) {

    }
  }, [authHeaders]);

  const saveAssign = useCallback(async () => {
    if (!assignGroup || !selectedIds[0]) return;
    setSaving(true);
    try {
      await axios.post(
        `/expertise/groups/${assignGroup.id}/assign-head`,
        { user_id: selectedIds[0] },
        { headers: authHeaders }
      );
      closeAssign();
      fetchGroups();
    } catch (e) {
      alert(e?.response?.data?.message || e?.message || t.error);
      setSaving(false);
    }
  }, [assignGroup, selectedIds, authHeaders, closeAssign, fetchGroups, t.error]);

  const removeResponsible = useCallback(async (group, uId) => {
    if (!group?.id || !uId) return;
    try {
      await axios.post(
        `/backoffice/groups/${group.id}/responsibles-remove`,
        { user_id: uId },
        { headers: authHeaders }
      );
      fetchGroups();
    } catch (e) {
      alert(e?.response?.data?.message || e?.message || t.error);
    }
  }, [authHeaders, fetchGroups, t.error]);

  /* ===================== effects ===================== */
useEffect(() => { fetchUserProfile(); fetchAvailableHeads(); }, []);
useEffect(() => { fetchGroups(page); }, [page, statusFilter]);

  useEffect(() => {
    setExpanded((prev) => {
      const next = {};
      groups.forEach((g) => { next[g.id] = prev[g.id] ?? false; });
      localStorage.setItem('gad2_expanded_groups', JSON.stringify(next));
      return next;
    });
  }, [groups]);

  /* ===================== filtered groups ===================== */
  const displayedGroups = useMemo(() => {
    if (!onlyUnassigned) return groups;
    return groups.filter((g) => {
      const resp = getResponsibles(g);
      const activeResp = resp.filter((r) => !r.removed_at);
      return activeResp.length === 0;
    });
  }, [groups, onlyUnassigned]);

  /* ===================== ui helpers ===================== */
  const onHeaderSort = (key) => {
    if (sortBy === key) setSortDir((d) => (d === 'asc' ? 'desc' : 'asc'));
    else { setSortBy(key); setSortDir('asc'); }
  };

  const isDeputyAccepted = useCallback((s) => {
    const v = String(s || '').toLowerCase().trim();
    return [
      'зам директор 2 қабылдады',
      'директор орынбасары қабылдады',
      'deputy_director_2 принял',
      'заместитель директора принял',
    ].includes(v);
  }, []);

  const displayStatus = useCallback((st) => {
    const raw = typeof st === 'object' ? (locale === 'kz' ? st.name_kz : st.name_ru) : (st || '');
    const v = raw.toLowerCase().trim();
    if (['зам директор 2 қабылдады', 'директор орынбасары қабылдады'].includes(v) && locale === 'kz') {
      return 'Директор орынбасары қабылдады';
    }
    if (['deputy_director_2 принял', 'заместитель директора принял'].includes(v) && locale === 'ru') {
      return 'Заместитель директора принял';
    }
    return raw;
  }, [locale]);

  const toggleGroup = useCallback((id) => {
    setExpanded((prev) => {
      const next = { ...prev, [id]: !(prev[id] ?? false) };
      localStorage.setItem('gad2_expanded_groups', JSON.stringify(next));
      return next;
    });
  }, []);

  const toggleAllGroups = useCallback(() => {
    setExpanded((prev) => {
      const next = { ...prev };
      const target = !anyOpen;
      groups.forEach((g) => (next[g.id] = target));
      localStorage.setItem('gad2_expanded_groups', JSON.stringify(next));
      return next;
    });
  }, [anyOpen, groups]);

  const openGroup = useCallback((id) => {
    setExpanded((prev) => {
      const next = { ...prev, [id]: true };
      localStorage.setItem('gad2_expanded_groups', JSON.stringify(next));
      return next;
    });
  }, []);

  const handleApproveGroup = useCallback(async (group) => {
    if (!window.confirm(t.confirmApprove)) return;
    setApprovingGroupId(group.id);
    try {
      await Promise.all(
        (group.applications || []).map((app) =>
          axios.post(`/expertise/applications/${app.id}/accept`, {}, { headers: authHeaders })
        )
      );
      alert(t.successApprove);
      await fetchGroups();
      openGroup(group.id);
    } catch (err) {

      alert(t.error);
    } finally {
      setApprovingGroupId(null);
    }
  }, [authHeaders, fetchGroups, openGroup, t]);

  const handleSelectHead = useCallback(async (groupId, headId) => {
    if (!window.confirm(t.confirmAssign)) return;
    setAssigningGroupId(groupId);
    try {
      await axios.post(`/expertise/groups/${groupId}/assign-head`, { user_id: headId }, { headers: authHeaders });
      alert(t.successAssign);
      await fetchGroups();
      setSelectingGroupId(null);
      openGroup(groupId);
    } catch (err) {

      alert(t.error);
    } finally {
      setAssigningGroupId(null);
    }
  }, [authHeaders, fetchGroups, openGroup, t]);

  /* ===================== sign/review modal loaders ===================== */
  const loadExternalProgress = useCallback(async (applicationId) => {
    const { data } = await axios.get(
      `/expertise/internal/applications/${applicationId}/external-progress`,
      { headers: authHeaders }
    );
    return {
      experts: Array.isArray(data?.experts) ? data.experts : [],
      finalAverage: data?.final_average ?? null,
      summaryDecision: data?.summary_decision ?? '',
    };
  }, [authHeaders]);

  async function openApplicationSign(app) {
    try {
      setOpeningSign(true);
      const docRes = await axios.get(`/final-documents/by-application/${app.id}`, { headers: authHeaders });
      const statusRes = await axios.get(
        `/final-documents/${docRes.data.document_id}/signatures/status`,
        { headers: authHeaders }
      );
      const pdfRes = await axios.get(
        `/final-documents/${docRes.data.document_id}/base64`,
        { headers: authHeaders }
      );
      setSelectedApplication({
        ...app,
        document_id: docRes.data.document_id,
        title: docRes.data.application_data?.title ?? app.title,
        category: docRes.data.application_data?.category ?? app.category,
        authors: docRes.data.application_data?.authors,
        publisher: docRes.data.application_data?.publisher ?? app.publisher,
        grade: docRes.data.application_data?.grade ?? app.grade,
      });
      setFinalAverage(docRes.data.average_score);
      setSummaryDecision(docRes.data.verdict);
      setSignatures(docRes.data.signers || []);
      setPendingSignatures(statusRes.data.not_signed || []);
      setBase64File(pdfRes.data.base64);
    } catch (err) {

      alert(t.alerts.errorOccurred);
    } finally {
      setOpeningSign(false);
    }
  }

  async function openApplicationReview(app) {
    try {
      setOpeningReview(true);
      const [{ data }, ext] = await Promise.all([
        axios.get(`/expertise/internal/final-documents/${app.id}`, { headers: authHeaders }),
        loadExternalProgress(app.id),
      ]);
      const docs = Array.isArray(data?.documents) ? data.documents : [];
      const active =
        docs.find((d) => d?.is_active) ||
        [...docs].sort(
          (a, b) => new Date(b?.updated_at || b?.created_at || 0) - new Date(a?.updated_at || a?.created_at || 0)
        )[0] || null;

      setReviewApp({ ...app });
      setReviewFinalDocuments(docs);
      setReviewExperts(
  (ext.experts || []).map((e) => ({
    id: e.id,
    name: e.name,
    subject: e.subject || '—',
    status: e.status || '—',
    score: e.score ?? '—',
    has_mistakes_file: !!e.has_mistakes_file,
    has_decision_file: !!e.has_decision_file,
    is_primary_scientist: e.is_primary_scientist ?? false,  // ← добавили
    academic_degree: e.academic_degree || '',               // ← добавили
  }))
);
      setReviewFinalAverage(ext.finalAverage ?? active?.average_score ?? null);
      setReviewSummaryDecision(ext.summaryDecision || active?.verdict || '');
    } catch (err) {

      alert(t.alerts.errorOccurred);
    } finally {
      setOpeningReview(false);
    }
  }

  /* ===================== signing actions ===================== */
  async function handleSign() {
    if (!base64File) return alert(t.alerts.fileNotLoaded);
    window.blockScreen?.();
    window.createCAdESFromBase64('PKCS12', 'SIGNATURE', base64File, false, async function (result) {
      window.unblockScreen?.();
      if (result.code !== '200') {
        alert(t.alerts.signError + result.message);
        return;
      }
      try {
        await axios.post(
          `/final-documents/sign/${selectedApplication.document_id}`,
          {
            signed_pdf_base64: result.responseObject,
            filename: `signed_doc_${selectedApplication.document_id}_${userId}.pdf`,
          },
          { headers: authHeaders }
        );
        alert(t.alerts.signSuccess);
        setSelectedApplication(null);
        fetchGroups();
      } catch (err) {
        alert(err.response?.data?.message || t.alerts.errorOccurred);
      }
    });
  }

  async function handleReject() {
    try {
      const currentSig = pendingSignatures.find((sig) => sig.user_id === userId);
      if (!currentSig) return alert(t.alerts.rejectQueueError);
      await axios.post(`/final-documents/reject/${currentSig.id}`, {}, { headers: authHeaders });
      alert(t.alerts.rejectSuccess);
      setSelectedApplication(null);
      fetchGroups();
    } catch (err) {
      alert(err.response?.data?.message || t.alerts.generalRejectError);
    }
  }

  async function downloadFinalPdf(finalDocId) {
    try {
      const res = await axios.get(`/final-documents/download-pdf/${finalDocId}`, {
        responseType: 'blob',
        headers: authHeaders,
      });
      const blob = new Blob([res.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `final_document_${finalDocId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {

      alert(t.alerts.fileDownloadError);
    }
  }

  async function downloadMistakesFile(applicationId, expertId) {
    try {
      const res = await axios.get(
        `/expertise/internal/applications/${applicationId}/external-experts/${expertId}/mistakes/download`,
        { responseType: 'blob', headers: authHeaders }
      );
      const blob = new Blob([res.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `mistakes_${expertId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {

      alert(t.alerts.fileDownloadError);
    }
  }

  async function downloadDecisionFile(applicationId, expertId) {
    try {
      const res = await axios.get(
        `/expertise/internal/applications/${applicationId}/external-experts/${expertId}/decision/download`,
        { responseType: 'blob', headers: authHeaders }
      );
      const blob = new Blob([res.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `decision_${expertId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {

      alert(t.alerts.fileDownloadError);
    }
  }

  const trExpertStatus = useCallback((s) => s || '—', []);
  const trVerdict = useCallback((v) => v || '—', []);

  /* ===================== render ===================== */
  if (loading && groups.length === 0) return <p>{t.loading}</p>;
  if (!loading && !groups.length && !error) return <p>{t.empty}</p>;

  return (
    <div className="gad2">
      {/* Toolbar */}
      <div className="gad2-toolbar">
        <div className="gad2-left">
          <button className="gad2-btn" onClick={toggleAllGroups}>
            {anyOpen ? t.collapseAll : t.expandAll}
          </button>

          <button
            className={`gad2-btn ${onlyUnassigned ? 'is-active' : ''}`}
            onClick={() => setOnlyUnassigned((v) => !v)}
            title={onlyUnassigned ? t.filterAll : t.filterUnassigned}
          >
            {onlyUnassigned ? `✕ ${t.filterAll}` : `⚑ ${t.filterUnassigned}`}
          </button>

          {onlyUnassigned && (
            <span className="gad2-filter-badge">
              {displayedGroups.length}
            </span>
          )}
        </div>
      </div>

      {error && <div className="gad2-error">{error}</div>}

      {/* List */}
      {displayedGroups.map((group) => {
        const apps = Array.isArray(group.applications) ? group.applications : [];
        const responsibles = getResponsibles(group);

        const allNeedApproval = apps.length > 0 && apps.every((app) => {
          const s = getStatusName(app.status);
          return s === 'Сараптамаға қабылданды' || s === 'Принято на экспертизу';
        });

        const allReadyForAssign = apps.length > 0 && apps.every((app) => {
          const s = getStatusName(app.status);
          return isDeputyAccepted(s);
        });

        const alreadyAssigned = apps.length > 0 && apps.every((app) => !!app.assigned_head_id);
        const isGroupOpen = expanded[group.id] ?? false;

        const summary = groupSummaries[group.id];
        const timeText = summary ? formatTimeLeft(summary.deadline_at) : '—';
        const severity = getTimeSeverity(summary?.deadline_at);

        // ── данные для блока "Общая информация" ──
        const regNumber = group.registration_number || '—';
        const groupDate = group.sent_at
          ? String(group.sent_at).slice(0, 10)
          : '—';

        // ── строим единый список для ResponsibleAvatars: head + responsibles ──
        const headEntry = group.assigned_head
          ? [{ ...group.assigned_head, _isHead: true }]
          : [];
        const combinedAssignees = [...headEntry, ...responsibles];

        return (
          <div key={group.id} className={`group-section ${isGroupOpen ? 'is-open' : 'is-closed'}`}>
            {/* HEADER */}
            <div
              className="gad2-group-header"
              role="button"
              tabIndex={0}
              onClick={() => toggleGroup(group.id)}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && toggleGroup(group.id)}
              aria-expanded={isGroupOpen}
              aria-controls={`gad2-panel-${group.id}`}
            >
              <span className="gad2-chev">{isGroupOpen ? '▾' : '▸'}</span>

              <span className="gad2-group-title">
                {group.title || '—'}
                {group.publisher_name && (
                  <span className="gad2-group-publisher"> — {group.publisher_name}</span>
                )}
              </span>

              {group.sent_at && (
                <span className="gad2-group-count" title="Жіберілген күні">
                  {group.sent_at}
                </span>
              )}

              <span className="gad2-group-count">{t.apps}: {apps.length}</span>

              <span
                className={`gad2-deadline ${severity} ${summary?.is_overdue ? 'overdue' : ''}`}
                title={summary
                  ? `${t.start}: ${summary.start_at || '—'}\n${t.deadline}: ${summary.deadline_at || '—'}`
                  : ''}
              >
                {timeText}
              </span>

              {allReadyForAssign && !alreadyAssigned && (
                <button
                  className="btn-assign-head"
                  onClick={(e) => {
                    e.stopPropagation();
                    openGroup(group.id);
                    setSelectingGroupId(group.id);
                  }}
                  disabled={assigningGroupId === group.id}
                >
                  {assigningGroupId === group.id ? t.loading : t.assign}
                </button>
              )}

              {/* ── Avatars: показываем и руководителя и ответственных ── */}
              <span
                onClick={(e) => e.stopPropagation()}
                style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}
              >
                <ResponsibleAvatars
  items={combinedAssignees}
  canManage={true}
  onViewProfile={openProfile}
  max={4}
  showAdd={true}
  addTitle={t.assignBtn}
  onAdd={(e) => {
    e.stopPropagation();
    openAssign(group, e.currentTarget);
  }}
  onRemove={(uid) => removeResponsible(group, uid)}
  label={t.assignees}
/>
              </span>
            </div>

            {/* Progress bar */}
            {isGroupOpen && summary?.progress_percent != null && (
              <div
                className="gad2-progress"
                role="progressbar"
                aria-valuenow={Math.round(summary.progress_percent * 100)}
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <div
                  className="gad2-progress-bar"
                  style={{ width: `${Math.round(summary.progress_percent * 100)}%` }}
                />
              </div>
            )}

            {/* Panel */}
            {isGroupOpen && (
              <div id={`gad2-panel-${group.id}`} className="gad2-group-panel">

                {/* ══════════════════════════════════════════════
                    БЛОК: Общая информация группы (как у директора)
                    ══════════════════════════════════════════════ */}
                <div className="gl-ginfo">
                  <div className="gl-ginfo__head">
                    <div className="gl-ginfo__title">{t.groupInfoTitle}</div>
                  </div>

                  <div className="gl-ginfo__grid">
                    {[
                      [t.registration_number, regNumber],
                      [t.subject,             localizedName(group.subject, locale)],
                      [t.grade,               localizedName(group.grade, locale)],
                      [t.education_level,     localizedName(group.education_level || group.educationLevel, locale)],
                      [t.direction,           localizedName(group.direction, locale)],
                      [t.development_language,localizedName(group.development_language || group.developmentLanguage, locale)],
                      [t.teaching_language,   localizedName(group.teaching_language || group.teachingLanguage, locale)],
                      [t.publication_type,    localizedName(group.publication_type || group.publicationType, locale)],
                      [t.service_type,        localizedName(group.service_type || group.serviceType, locale)],
                      [t.submission_year,     localizedName(group.submission_year || group.submissionYear, locale)],
                      [t.sent_at,             groupDate],
                    ].map(([label, value]) => (
                      <div key={label} className="gl-ginfo__item">
                        <div className="gl-ginfo__label">{label}</div>
                        <div className="gl-ginfo__value">{value || '—'}</div>
                      </div>
                    ))}
                  </div>

                  {/* ── Руководитель + Ответственные ── */}
                  <div className="gl-ginfo__assignments">
                    {/* Руководитель отдела */}
                    <div className="gl-ginfo__assign-row">
                      <span className="gl-ginfo__assign-label">{t.head}:</span>
                      {group.assigned_head ? (
                        <span className="gl-ginfo__assign-value gl-ginfo__assign-value--head">
                          {group.assigned_head.user_name || '—'}
                        </span>
                      ) : (
                        <span className="gl-ginfo__assign-value gl-ginfo__assign-value--empty">—</span>
                      )}
                    </div>

                    {/* Ответственные сотрудники */}
                    <div className="gl-ginfo__assign-row">
                      <span className="gl-ginfo__assign-label">{t.responsibles}:</span>
                      {responsibles.length > 0 ? (
                        <span className="gl-ginfo__assign-value">
                          {responsibles
                            .filter((r) => !r.removed_at)
                            .map((r) => r.user_name)
                            .filter(Boolean)
                            .join(', ') || '—'}
                        </span>
                      ) : (
                        <span className="gl-ginfo__assign-value gl-ginfo__assign-value--empty">—</span>
                      )}
                    </div>
                  </div>
                </div>
                {/* ══ конец блока общей информации ══ */}

                {/* Таблица заявок */}
                <table className="custom-table" aria-label="applications-table">
                  <thead>
                    <tr>
                      <Th label={t.tableHeaders.category} />
                      <ThSort label={t.tableHeaders.publisher} sortKey="publisher_name" sortBy={sortBy} sortDir={sortDir} onSort={onHeaderSort} />
                      <Th label={t.tableHeaders.status} />
                      <ThSort label={t.tableHeaders.date}      sortKey="created_at"     sortBy={sortBy} sortDir={sortDir} onSort={onHeaderSort} />
                      <Th label={t.tableHeaders.action} />
                    </tr>
                  </thead>
                  <tbody>
                    {apps.map((app) => {
                      const dl = app?.deadline;
                      return (
                        <tr key={app.id}>
                          <td>{app.category || '—'}</td>
                          <td>{group.encrypted_publisher_name || group.publisher_name || '—'}</td>
                          <td>{displayStatus(app.status)}</td>
                          <td title={dl?.deadline_at ? `${t.deadline}: ${dl.deadline_at}` : undefined}>
                            {app.created_at || '—'}
                          </td>
                          <td className="gad2-actions-cell">
  <button className="btn-view" onClick={() => setSelectedApplicationId(app.id)}>
    {t.view}
  </button>
  <button
    className="btn-secondary"
    onClick={() => openApplicationReview(app)}
    disabled={openingReview}
  >
    {openingReview ? '…' : t.viewExperts}
  </button>
  <button
    className="btn-primary"
    onClick={() => openApplicationSign(app)}
    disabled={openingSign}
  >
    {openingSign ? '…' : t.sign}
  </button>
</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>

                {selectingGroupId === group.id && (
                  <div className="select-head-list">
                    <h4>{t.selectHead}:</h4>
                    {heads.length === 0 ? (
                      <p className="muted">—</p>
                    ) : (
                      <ul>
                        {heads.map((head) => (
                          <li key={head.id}>
                            <button
                              className="btn-select-head"
                              title={head.name}
                              onClick={() => handleSelectHead(group.id, head.id)}
                            >
                              {head.name}
                            </button>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        );
      })}

      {/* Pagination */}
      <Pagination
        meta={meta}
        page={meta.current_page || page}
        onPrev={() => setPage((p) => Math.max(1, p - 1))}
        onNext={() => setPage((p) => Math.min(meta.last_page || 1, p + 1))}
        onGoto={(p) => setPage(p)}
      />

      {/* Application view modal */}
      {selectedApplicationId && (
        <ApplicationViewDeputy2
          applicationId={selectedApplicationId}
          onClose={() => { setSelectedApplicationId(null); fetchGroups(); }}
          onChanged={fetchGroups}
        />
      )}

      {/* Signature modal */}
      {selectedApplication && (
        <SignatureApplicationModal
          application={selectedApplication}
          onClose={() => setSelectedApplication(null)}
          locale={locale}
          finalAverage={finalAverage}
          summaryDecision={summaryDecision}
          t={t}
          downloadFinalDecision={() => downloadFinalPdf(selectedApplication.document_id)}
          showSignatures={showSignatures}
          setShowSignatures={setShowSignatures}
          signatures={signatures}
          userId={userId}
          pendingSignatures={pendingSignatures}
          handleSign={handleSign}
          handleReject={handleReject}
        />
      )}

      {/* Review modal */}
      {reviewApp && (
        <ApplicationReviewModal
          isOpen
          application={reviewApp}
          experts={reviewExperts}
          locale={locale}
          t={t}
          finalAverage={reviewFinalAverage}
          summaryDecision={reviewSummaryDecision}
          trExpertStatus={trExpertStatus}
          trVerdict={trVerdict}
          onClose={() => { setReviewApp(null); setChatOpen(false); }}
          downloadFinalDecision={(finalDocId) => downloadFinalPdf(finalDocId)}
          finalDocuments={reviewFinalDocuments}
          downloadMistakesFile={downloadMistakesFile}
          downloadDecisionFile={downloadDecisionFile}
          onOpenChat={() => setChatOpen(true)}
          ChatBoxComponent={ChatBox}
          chatBoxProps={{
            key: `chat-${reviewApp.id}-${chatOpen}`,
            isOpen: chatOpen,
            onClose: () => setChatOpen(false),
            applicationId: reviewApp.id,
            currentUserId: userId,
            lang: locale === 'kz' ? 'kk' : locale,
            token,
            isDeputyDirector: true,
          }}
        />
      )}

      {/* Assign staff popover */}
      <AssignStaffPopover
        open={assignOpen}
        anchorEl={assignAnchorEl}
        title={t.modalTitle}
        subtitle={assignGroup?.title || (assignGroup ? `#${assignGroup.id}` : '')}
        headers={authHeaders}
        staffEndpoint="/backoffice/users"
        staffParams={staffParams}
        value={selectedIds}
        onChange={setSelectedIds}
        onClose={closeAssign}
        onSave={saveAssign}
        saving={saving}
        loadingText={t.loading}
        emptyText={t.staffEmpty}
        cancelText={t.cancel}
        saveText={t.save}
      />

      {profileOpen && (
  <div
    className="ga-modal-backdrop"
    role="dialog"
    aria-modal="true"
    onClick={closeProfile}
  >
    <div
      className="ga-modal-card ga-modal-card--xl"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="ga-modal-head">
        <h3 className="ga-modal-title">
          {locale === 'kz' ? 'Қолданушы профилі' : 'Профиль пользователя'}
        </h3>
        <button type="button" className="ga-modal-close" onClick={closeProfile}>×</button>
      </div>
      <div className="ga-modal-body">
        {profileLoading ? (
          <p>{t.loading}</p>
        ) : (
          <UserProfileModal
            user={profileUser}
            userDetails={profileDetails}
            locale={locale}
            canWriteReview={false}
            canManageReview={false}
          />
        )}
      </div>
    </div>
  </div>
)}
    </div>
  );
}

/* ===================== small presentational helpers ===================== */
function Th({ label }) { return <th>{label}</th>; }

function ThSort({ label, sortKey, sortBy, sortDir, onSort }) {
  const active = sortBy === sortKey;
  return (
    <th
      className={`th-sort ${active ? 'is-active' : ''}`}
      onClick={() => onSort(sortKey)}
      role="button"
      tabIndex={0}
    >
      <span>{label}</span>
      <span className="sort-caret">{active ? (sortDir === 'asc' ? '▲' : '▼') : '↕'}</span>
    </th>
  );
}

function Pagination({ meta, page, onPrev, onNext, onGoto }) {
  const total = meta?.total ?? 0;
  const last = meta?.last_page ?? 1;
  const from = meta?.from ?? 0;
  const to = meta?.to ?? 0;

  const win = 2;
  const start = Math.max(1, page - win);
  const end = Math.min(last, page + win);
  const pages = [];
  for (let p = start; p <= end; p++) pages.push(p);

  return (
    <div className="gad2-pager">
      <div className="gad2-pager-info">{total > 0 ? `${from}–${to} / ${total}` : ''}</div>
      <div className="gad2-pager-buttons">
        <button className="gad2-btn" onClick={onPrev} disabled={page <= 1}>‹</button>
        {start > 1 && (
          <>
            <button className={`gad2-btn ${page === 1 ? 'is-current' : ''}`} onClick={() => onGoto(1)}>1</button>
            {start > 2 && <span className="dots">…</span>}
          </>
        )}
        {pages.map((p) => (
          <button key={p} className={`gad2-btn ${page === p ? 'is-current' : ''}`} onClick={() => onGoto(p)}>{p}</button>
        ))}
        {end < last && (
          <>
            {end < last - 1 && <span className="dots">…</span>}
            <button className={`gad2-btn ${page === last ? 'is-current' : ''}`} onClick={() => onGoto(last)}>{last}</button>
          </>
        )}
        <button className="gad2-btn" onClick={onNext} disabled={page >= last}>›</button>
      </div>
    </div>
  );
}